<div class="header-company-list-content">
	<div *ngIf="showFilter" class="px-3 pt-3 pb-2">
		<input #filterInput type="text" class="form-control" placeholder="Caută..."
			[(ngModel)]="filter" (keydown)="onFilterKeyDown($event)" />
	</div>
	<div #companyListContainer class="company-list">
		<div *ngFor="let company of filteredCompanies; let i = index"
			class="d-flex align-items-center px-3 py-2 cursor-pointer companyAction"
			[class.selected]="i === selectedIndex"
			(click)="onCompanyClick(company.externalId)">
			{{ company.fiscalNumber }} - {{ company.companyName }}
		</div>
	</div>
</div>
